import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import animation from "../../../../Animation/services.json";

import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";
import Lottie from "react-lottie";
const EducationTab = () => {
  const {t , i18n}=useTranslation()
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  gsap.registerPlugin(ScrollTrigger);
  useGSAP(() => {
  
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });
  return (
    <div className="WebDevelopment">
      <div className="svg">
        <div className="flex flex-col items-start">
          <h4>{t("BESPOKE SOLUTION")}</h4>
          <h5>{t("Education management services")}</h5>
          <div ref={lottieContainerRef} className="w-[80vw] md:w-[35vw] mt-[5vh]">
          {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
          </div>
        </div>
      </div>
      <div className="content">
        <p>
          {t("we turn educational content into complete, high-performing digital learning products. With a strong portfolio in the education sector serving universities, academies, and professional instructors we deliver this service with real confidence and deep understanding. From filming and editing the course to designing, operating, and securing the platform, we cover the full digital learning journey from concept to a fully functional, scalable product.")}
        </p>
        <ul>
          <li>
            {t("We film and edit course content with high production value to ensure clarity and engagement.")}
          </li>
          <li>
            {t("Our platforms are custom-built to fit your subject, audience, and brand no templates")}
          </li>
          <li>
            {t("UX/UI design is learner-centric: smooth, simple, and intuitive.")}
          </li>
          <li>
            {t("We secure your content with advanced protection against copying, leaks, and piracy.")}
          </li>
          <li>
            {t("We create tailored marketing campaigns to position and promote your course online.")}
          </li>
          <li>
            {t("We handle full technical support and guide the user journey from first click to final certification.")}
          </li>
        </ul>
        <Link className="btn-hover" to="/education">
          <span>{t("Education Services")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m12.404 8.303l3.431 3.327c.22.213.22.527 0 .74l-6.63 6.43C8.79 19.201 8 18.958 8 18.43v-5.723z"
              />
              <path
                fill="currentColor"
                d="M8 11.293V5.57c0-.528.79-.771 1.205-.37l2.481 2.406z"
                opacity="0.5"
              />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default EducationTab;
